import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchUserSubscriptions } from '../../api/subscription';
import { ISubscription } from './types';

export const fetchSubscriptions = createAsyncThunk(
  'subscriptions/fetchSubscriptions',
  async (userID?: string | undefined): Promise<ISubscription[]> => {
    if (!userID) throw new Error('user_id not loaded yet');
    const response = await fetchUserSubscriptions(userID);

    return response;
  }
);
